export default __webpack_public_path__ + "static/media/product-owner.7be6b41f.png";